import React, { useEffect, useState } from 'react';
import { fetchWithCredentials, API_ENDPOINTS } from '../config/api';
import { useNavigate } from 'react-router-dom';

function AdminPage() {
  const [stats, setStats] = useState(null);
  const [configs, setConfigs] = useState([]);
  const [admins, setAdmins] = useState([]); // 管理员列表
  const [newAdminEmail, setNewAdminEmail] = useState('');
  const [adminError, setAdminError] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // 检查管理员权限
    fetchWithCredentials('/api/admin/stats')
      .then(data => setStats(data))
      .catch(err => {
        setError('无权限或未登录');
        setTimeout(() => navigate('/'), 1500);
      });

    fetchWithCredentials('/api/admin/payment-config')
      .then(data => setConfigs(data))
      .catch(() => {});

    fetchWithCredentials('/api/admin/admins')
      .then(data => setAdmins(data))
      .catch(() => {});
  }, [navigate]);

  const handleConfigChange = (key, value) => {
    setConfigs(configs.map(cfg => cfg.key === key ? { ...cfg, value } : cfg));
  };

  const saveConfig = (key, value) => {
    fetchWithCredentials('/api/admin/payment-config', {
      method: 'POST',
      body: JSON.stringify({ key, value })
    }).then(() => alert('保存成功'));
  };

  // 管理员相关
  const handleAddAdmin = async () => {
    setAdminError('');
    if (!newAdminEmail) {
      setAdminError('请输入邮箱');
      return;
    }
    try {
      const res = await fetchWithCredentials('/api/admin/admins', {
        method: 'POST',
        body: JSON.stringify({ email: newAdminEmail })
      });
      setAdmins([...admins, { userId: res.admin.userId, email: res.admin.email }]);
      setNewAdminEmail('');
    } catch (e) {
      setAdminError(e.message || '添加失败');
    }
  };

  const handleRemoveAdmin = async (userId) => {
    if (!window.confirm('确定要移除该管理员吗？')) return;
    try {
      await fetchWithCredentials('/api/admin/admins', {
        method: 'DELETE',
        body: JSON.stringify({ userId })
      });
      setAdmins(admins.filter(a => a.userId !== userId));
    } catch (e) {
      setAdminError(e.message || '删除失败');
    }
  };

  if (error) return <div style={{ color: 'red', textAlign: 'center', marginTop: 40, fontSize: 18 }}>{error}</div>;
  if (!stats) return <div style={{ textAlign: 'center', marginTop: 40, fontSize: 18 }}>加载中...</div>;

  // 统计类型映射
  const statsMap = [
    { key: 'today', label: '今日' },
    { key: 'week', label: '本周' },
    { key: 'month', label: '本月' },
    { key: 'all', label: '全部' }
  ];

  return (
    <div style={{ maxWidth: 1100, margin: '40px auto', padding: 32, background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
      <h1 style={{ textAlign: 'center', marginBottom: 32, fontWeight: 700, letterSpacing: 2 }}>后台管理</h1>
      <h2 style={{ margin: '0 0 24px 0', fontWeight: 600, borderLeft: '4px solid #1976d2', paddingLeft: 12 }}>订单统计</h2>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 40, gap: 24 }}>
        {statsMap.map(({ key, label }) => (
          <div key={key} style={{ flex: 1, background: '#f6f8fa', borderRadius: 12, padding: 20, textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }}>
            <div style={{ fontWeight: 600, fontSize: 18, color: '#1976d2', marginBottom: 10 }}>{label}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ fontSize: 22, color: '#1976d2', fontWeight: 700 }}>订单总数：{stats[key]?.totalOrders ?? 0}</div>
              <div style={{ fontSize: 18, color: '#43a047' }}>已支付：{stats[key]?.paidOrders ?? 0}</div>
              <div style={{ fontSize: 18, color: '#fbc02d' }}>未支付：{stats[key]?.unpaidOrders ?? 0}</div>
              <div style={{ fontSize: 18, color: '#e53935' }}>总交易额：{stats[key]?.totalAmount ?? 0} USD</div>
            </div>
          </div>
        ))}
      </div>

      <h2 style={{ margin: '32px 0 16px 0', fontWeight: 600, borderLeft: '4px solid #1976d2', paddingLeft: 12 }}>支付通道参数配置</h2>
      <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fafbfc', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
        <thead style={{ background: '#f0f4f8' }}>
          <tr>
            <th style={{ padding: '12px 8px', fontWeight: 600, color: '#333', borderBottom: '1px solid #e0e0e0' }}>参数</th>
            <th style={{ padding: '12px 8px', fontWeight: 600, color: '#333', borderBottom: '1px solid #e0e0e0' }}>值</th>
            <th style={{ padding: '12px 8px', fontWeight: 600, color: '#333', borderBottom: '1px solid #e0e0e0' }}>操作</th>
          </tr>
        </thead>
        <tbody>
          {configs.map(cfg => (
            <tr key={cfg.key} style={{ transition: 'background 0.2s' }}>
              <td style={{ padding: '10px 8px', borderBottom: '1px solid #f0f0f0', color: '#444' }}>{cfg.key}</td>
              <td style={{ padding: '10px 8px', borderBottom: '1px solid #f0f0f0' }}>
                <textarea
                  value={cfg.value || ''}
                  onChange={e => handleConfigChange(cfg.key, e.target.value)}
                  style={{ width: 420, minHeight: 38, maxHeight: 80, padding: '6px 10px', border: '1px solid #bdbdbd', borderRadius: 6, fontSize: 15, outline: 'none', background: '#fff', transition: 'border 0.2s', resize: 'vertical' }}
                  rows={2}
                  onFocus={e => e.target.style.border = '1.5px solid #1976d2'}
                  onBlur={e => e.target.style.border = '1px solid #bdbdbd'}
                />
              </td>
              <td style={{ padding: '10px 8px', borderBottom: '1px solid #f0f0f0' }}>
                <button
                  onClick={() => saveConfig(cfg.key, cfg.value)}
                  style={{ padding: '6px 18px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 15, boxShadow: '0 1px 4px rgba(25,118,210,0.08)', transition: 'background 0.2s' }}
                  onMouseOver={e => e.target.style.background = '#1565c0'}
                  onMouseOut={e => e.target.style.background = '#1976d2'}
                >保存</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 style={{ margin: '32px 0 16px 0', fontWeight: 600, borderLeft: '4px solid #1976d2', paddingLeft: 12 }}>管理员管理</h2>
      <div style={{ background: '#f6f8fa', borderRadius: 10, padding: 24, marginBottom: 32, boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
          <input
            type="email"
            placeholder="输入用户邮箱添加管理员"
            value={newAdminEmail}
            onChange={e => setNewAdminEmail(e.target.value)}
            style={{ width: 320, padding: '8px 12px', border: '1px solid #bdbdbd', borderRadius: 6, fontSize: 15, outline: 'none' }}
          />
          <button
            onClick={handleAddAdmin}
            style={{ padding: '8px 20px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 15 }}
          >添加管理员</button>
          {adminError && <span style={{ color: 'red', marginLeft: 16 }}>{adminError}</span>}
        </div>
        <table style={{ width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.03)' }}>
          <thead>
            <tr style={{ background: '#f0f4f8' }}>
              <th style={{ padding: '10px 8px', fontWeight: 600, color: '#333' }}>邮箱</th>
              <th style={{ padding: '10px 8px', fontWeight: 600, color: '#333' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {admins.map(a => (
              <tr key={a.userId}>
                <td style={{ padding: '10px 8px', color: '#444' }}>{a.email}</td>
                <td style={{ padding: '10px 8px' }}>
                  <button
                    onClick={() => handleRemoveAdmin(a.userId)}
                    style={{ padding: '6px 16px', background: '#e53935', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 15 }}
                  >移除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminPage;